import { render, staticRenderFns } from "./DatingDemo.vue?vue&type=template&id=28260396&"
import script from "./DatingDemo.vue?vue&type=script&lang=js&"
export * from "./DatingDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports